import React, { Dispatch, useEffect, useState, SetStateAction } from 'react';
import Draggable, { DraggableEvent, DraggableData } from 'react-draggable';
import { IInject, ILayout } from '../interfaces';
import ReactSlider from 'react-slider'
import _ from 'lodash';

interface MiniTimelineProps {
    injectComponents: IInject[];
    setTimelineX: Dispatch<SetStateAction<number>>;
    showMiniTimeline: string;
    gameTimeInterval: number;
    saveLayouts: { [index: string]: ILayout[] };
    setZoomLevel: Dispatch<SetStateAction<number>>;
    zoomLevel: number;
    miniLeft: {x: number, y: number} | undefined;
    setWindowWidth: Dispatch<SetStateAction<number>>; 
    windowWidth: number;
    setMiniLeft: Dispatch<SetStateAction<{x: number, y: number} | undefined>>;
}

interface IMiniTimeline {
    turn: number;
    injects: ITimelineInject[];
}

interface ITimelineInject {
    injectTop: number;
    injectName: string;
    turnLength: number;
    startTurn: number;
    turnOrder: number;
    turnActive: boolean[] | null;
}

const MiniTimeline: React.FC<MiniTimelineProps> = ({ injectComponents, setTimelineX, showMiniTimeline, gameTimeInterval, saveLayouts, setZoomLevel, zoomLevel, setMiniLeft, miniLeft, setWindowWidth, windowWidth }) => {

    const [miniTimeline, setMiniTimeline] = useState<IMiniTimeline[]>([])
    const [rightBounds, setRightBounds] = useState<number>(0)
    const [level, setLevel] = useState<number>(1)
    const nodeRef = React.useRef(null);
    const turnWidthBig: number = 272
    const zoom4width: number = 358
    const zoom5width: number = 180
    const turnPadding: number = 4
    let turnWidth: number = level === 1 ? turnWidthBig / (gameTimeInterval + 1) : turnWidthBig / (gameTimeInterval + 1);

    const handleDrag = (e: DraggableEvent, ui: DraggableData) => {
        setMiniLeft(undefined)
        setTimelineX(ui.x)
    };

    useEffect(() => {
        if (zoomLevel === 4) {
            setLevel(1)
        } else {
            setLevel(0)
        }
    }, [zoomLevel]);

    const calcTimeline = () => {
        
        const turnLength = zoomLevel === turnPadding ? zoom4width : zoom5width
        const totalScenarioWidth = gameTimeInterval === 10 ? (turnLength * gameTimeInterval) : turnLength * (gameTimeInterval + 1) + zoom5width

        // ... below is the replacement for the switch
        const originalViewportWidth = 280+16 // these values are from the css file, if we can pull these from the css file, even better
        // if our browser window is wider than our scenario
        if(window.innerWidth > totalScenarioWidth) {
            setWindowWidth(originalViewportWidth)
            setRightBounds(0)
        // else our scenario is wider than our browser window
        } else {
            const viewRatio = window.innerWidth / totalScenarioWidth
            const rb = originalViewportWidth * (1.0-viewRatio)
            if (miniLeft !== undefined) {
                if (miniLeft!.x + (originalViewportWidth * viewRatio) > originalViewportWidth) {
                    setMiniLeft({x: miniLeft.x - 8, y: miniLeft.y})
                }
            }
            setWindowWidth(originalViewportWidth * viewRatio)
            setRightBounds(rb)
        }
    }

    const recalcTimeline = _.debounce(() => calcTimeline(), 250)
    window.addEventListener('resize', recalcTimeline);

    useEffect(() => {
        calcTimeline();
    }, [gameTimeInterval, zoomLevel]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        
        let tempInjects = JSON.parse(JSON.stringify(injectComponents))

        if (!_.isEmpty(saveLayouts)) {
            for (let k = 0; k<tempInjects.length; k++) {
                for (let l = 0; l<saveLayouts.injects.length; l++) {
                    if (tempInjects[k].id === saveLayouts.injects[l].i) {
                        tempInjects[k].startTurn = saveLayouts.injects[l].x;
                        tempInjects[k].turnLength = saveLayouts.injects[l].w;
                        tempInjects[k].turnOrder = saveLayouts.injects[l].y;
                    }
                }
            }

            let miniTimeline1: IMiniTimeline[] = [];
    
            for (let i = 0; i<gameTimeInterval; i++) {
                let turn: IMiniTimeline = {
                    turn: i,
                    injects: []
                };
                miniTimeline1.push(turn);
            }

            for (let m = 0; m<miniTimeline1.length; m++) {
                for (let l = 0; l<tempInjects.length; l++) {
                    if (tempInjects[l].startTurn === miniTimeline1[m].turn) {
                        let inject: ITimelineInject = {
                            injectTop: 0,
                            injectName: tempInjects[l].name,
                            turnLength: tempInjects[l].turnLength,
                            startTurn: tempInjects[l].startTurn,
                            turnOrder: tempInjects[l].turnOrder,
                            turnActive: tempInjects[l].nodes ? Array.from({length: tempInjects[l].turnLength}, (i, idx) => 
                                tempInjects[l].nodes.findIndex((n: any) => n.turn === idx + 1) > -1
                            ) : null

                        }
                        miniTimeline1[m].injects.push(inject)
                    }
                }
            }

            let turnInjects: IMiniTimeline[] = [];
            
    
            for (let i = 0; i<gameTimeInterval; i++) {
                let turn: IMiniTimeline = {
                    turn: i,
                    injects: []
                };
                turnInjects.push(turn);
            }

            for (let q = 0; q<miniTimeline1.length; q++) {
                for (let i = 0; i<tempInjects.length; i++) {
                    for (let j = 0; j<turnInjects.length; j++) {
                        if (tempInjects[i].startTurn === turnInjects[j].turn) {
                            turnInjects[j].injects.push(tempInjects[i])
                        }
                    }
                }

                let injectTop1: number = 0;
                for (let i = 0; i<turnInjects.length; i++) {
                    
                    if (turnInjects[i].turn < miniTimeline1[q].turn) {
                        for (let j = 0; j<turnInjects[i].injects.length; j++) {
                        if (j <= i) {
                            if (turnInjects[i].injects[j].turnLength + turnInjects[i].turn - 1 >= miniTimeline1[q].turn) {
                                injectTop1 += 70;
                            }
                        }
                        }
                    }
                    if (turnInjects[i].turn === miniTimeline1[q].turn && miniTimeline1[q].turn > 1) {
                        for (let j = 0; j<turnInjects[i].injects.length; j++) {
                            if (j === 0) {
                                if (miniTimeline1[i].injects[j] !== undefined) {
                                    miniTimeline1[i].injects[j].injectTop += (j * 70) + injectTop1;
                                }
                            } else {
                                if (miniTimeline1[i].injects[j] !== undefined) {
                                    miniTimeline1[i].injects[j].injectTop += (j * 70) + injectTop1;
                                }
                            }
                        }
                    }
                }
            }

            setMiniTimeline(miniTimeline1)
        }
      }, [injectComponents, setMiniTimeline, gameTimeInterval, saveLayouts]);

    const onChangeLevel = (value: number, index: number) => {
        setLevel(value)
        switch(value) {
            case 0:
                setZoomLevel(5)
                break;
            case 1:
                setZoomLevel(4)
                break;
            default:
            break;
        }
    }

    return (
        <div className={`mini-timeline ${showMiniTimeline}`}>
            <div className="mini-timeline-content">
            <Draggable
                axis="x"
                bounds={{top: 0, left: 0, right: rightBounds, bottom: 0}}
                onDrag={handleDrag}
                nodeRef={nodeRef}
                position={miniLeft}
            >
                <div className={`mini-timeline-window handle`} style={{ width: windowWidth + 'px' }} ref={nodeRef}></div>
            </Draggable>
                
                {miniTimeline.map((turn, i) => {
                    return (
                        <div className="mini-turn" style={{ 'width': turnWidth + 'px' }} key={i}>
                            {miniTimeline[i].injects.map((item1: ITimelineInject, j: number) => {
                                
                                let injWidth: string = turnWidth * item1.turnLength + 4 + 'px';
                                // 11.487 determines how far the inject is from the top
                                let injTop: number = item1.turnOrder * 11.487
                                
                                if (i !== 0) {
                                    injTop += item1.turnOrder * 5
                                } else {
                                    if (j > 0) {
                                        injTop += item1.turnOrder * 5
                                    }
                                }

                                return (

                                    <div className="mini-inject" style={{ 'width': injWidth, 'top': injTop }} key={j}>
                                        {item1.turnActive &&
                                        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '14px'}}>
                                            {item1.turnActive.map((active: boolean, idx: number) => {
                                                return (
                                                    <div key={idx} className={'in-use'} style={{width: `${turnWidth}px`, opacity: active ? 0 : 0.35}}>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        }

                                        <div className="mini-icon">
                                            <img src="img/inject-exclaim.svg" alt="exclaim" />
                                        </div>
                                        <div className="title">{item1.injectName}</div>
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
                <div className="mini-turn" style={{ 'width': turnWidth + 'px' }}></div>
            </div>
            <div className="mini-min">0</div>
            <ReactSlider
                min={0}
                max={1}
                onChange={onChangeLevel}
                className="horizontal-slider mini-timeline-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={level}
                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
            />
            <div className="mini-max">100</div>
            <div className="mini-percent">{level * 100}%</div>
        </div>
    );
}

export default MiniTimeline;